import { MintingEnum } from '../../game-status/constants/game-status-enum';

import {
  takeMoneyBackMessages,
  technicalDefeatMessages,
  waitYourMoveMessages,
  waitYourRevealMessages,
} from 'shared/constants/text-loaders';

export const getMintingMessages = (mintingLoader: MintingEnum) => {
  switch (mintingLoader) {
    case MintingEnum.YOUR_MOVE:
      return waitYourMoveMessages;
    case MintingEnum.YOUR_REVEAL:
      return waitYourRevealMessages;
    case MintingEnum.TAKE_MONEY_BACK:
      return takeMoneyBackMessages;
    case MintingEnum.TECHNICAL_DEFEAT:
      return technicalDefeatMessages;
    default:
      return [];
  }
};
